import React from 'react';
import { JourneyStrip } from './JourneyStrip';
import { MAIN_MOCKUP } from '../data/unstuckContent';
export function SystemRevealSection() {
  return <section className="w-full border-y border-champagne/20 bg-black py-12 sm:py-16" aria-labelledby="reveal-title" data-id="element-193" data-mp="1yxq50mw10eyy">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-194" data-mp="1pyw1sdo6wqcf">
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-195" data-mp="1pxb8sshixfgo">
          The solution
        </p>
        <h2 id="reveal-title" className="mt-3 font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-196" data-mp="1g0ydxra8svkc">
          The UNSTUCK™ complete system
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-snug text-body sm:text-[16px]" data-id="element-197" data-mp="177v55wajl6w1">
          6 Volumes + 5 Bonuses · 340+ pages — dopamine reset, focus architecture and
          execution, everything solved.
        </p>

        <div className="mt-6 border-y border-charcoal-600 py-4" data-id="element-198" data-mp="x9yrawq7zxu8">
          <JourneyStrip data-id="element-199" data-mp="32hrm87qq660e" />
        </div>

        <img src={MAIN_MOCKUP} alt="The complete UNSTUCK system — six volumes and five strategic bonuses" className="mx-auto mt-8 w-full max-w-md sm:max-w-lg" width={1080} height={1080} data-id="element-200" data-mp="32gq1fbjwq55h" />
      </div>
    </section>;
}